import Heading from '@ilg-totallymoney/ui/components/Heading'
import Text from '@ilg-totallymoney/ui/components/Text'

const ContentPoorCredit = () => {
    return (
        <>
            <Heading variant="100" as="h1">
                Guide to loans for poor credit
            </Heading>
            <Heading variant="60" as="h2">
                What is a Bad Credit Loan?{' '}
            </Heading>
            <Text>
                Bad credit loans are designed for people who are looking for a
                loan but have a poor credit history. While having a bad credit
                rating can make it much harder to find cheap loans, there are
                still options available to you if you want to borrow money and
                avoid payday loans, which are extremely risky and can easily
                push you further into debt.
            </Text>
            <Text>
                As with any loan you need to be well informed before making a
                decision, however this is especially true if you need a loan but
                have a bad credit rating.{' '}
            </Text>
            <Text>
                It is also important to understand that having a poor credit
                history and having no credit history are different things.
                Having no credit history, also known as having a thin credit
                file, is usually experienced by young people who have never had
                a credit card and haven&#39;t been able to build up a credit
                rating.
            </Text>
            <Text>
                There are many reasons why someone might have a bad credit
                rating - perhaps mortgage repayments have been missed or you
                have had a County Court Judgment (CCJ) taken against you?
                Whatever your past, there are always options available to you.
            </Text>
            <Text>
                Here we look into the potential benefits and downfalls of bad
                credit loans, and let you know what you need to consider when
                looking into loans for people with bad credit.
            </Text>
            <Heading variant="60" as="h2">
                Pros and cons of bad credit loans
            </Heading>
            <Text>
                If you have poor credit history lenders will consider you a
                higher risk and therefore the loans you are likely to be
                eligible for will probably have a high level of interest. While
                you should look around at the various loan options available to
                you, it might be unlikely that you find an interest rate you are
                happy with.
            </Text>
            <Text>
                Of course if you do manage to find a bad credit loan that you
                are comfortable with and that you are confident you will be able
                to repay it can help you rebuild your credit rating (providing
                you don’t fall behind on repayments). This is because it will
                allow you to prove to lenders that you are able to handle your
                finances and responsibly borrow money, therefore you must take a
                disciplined approach to repaying the money you borrow.
            </Text>
            <Text>
                Bad credit loans can be used by people who have had problems
                with credit to consolidate their debts. However if this is your
                plan then there are other, less costly alternatives which we
                will look at below.
            </Text>
            <Heading variant="60" as="h2">
                Alternatives to bad credit loans{' '}
            </Heading>
            <Text>
                As we have said, you might struggle to find the best interest
                rates on loans or credit cards or you have a poor credit
                history, but that shouldn’t stop you from looking at all of your
                options. You should also consider what it is you need the loan
                for. If you are looking for a way to consolidate your debts a{' '}
                <a
                    href="https://www.totallymoney.com/loans/debt-consolidation/"
                    target="_blank"
                >
                    debt consolidation loan
                </a>{' '}
                is an option you could look into, however if you have a poor
                credit history then you might struggle to find a cheap debt
                consolidation loan.
            </Text>
            <Text>
                If you are hoping to borrow some money to make a one-off
                purchase then a{' '}
                <a
                    href="https://www.totallymoney.com/credit-cards/purchase/"
                    target="_blank"
                >
                    purchase card
                </a>{' '}
                is also an option you could look into. Many purchase cards offer
                0% introductory interest rates. If you are confident that you
                can repay all the money within the introductory period then this
                might be a good option for you.
            </Text>
            <Text>
                If you have poor credit history because you have fallen into
                debt then another loan might not be the right choice for you.
                There are other ways to take control of your finances, such as
                setting up standing orders to ensure you are not late on
                repayments or simply creating a personal budget and rigidly
                sticking to it.
            </Text>
            <Heading variant="60" as="h2">
                Things to remember about loans for people with bad credit{' '}
            </Heading>
            <Text>
                As you might have guessed, getting a loan when you have a bad
                credit history will be hard. However there are much, much worse
                options that might seem enticing if you desperately need cash.
                We would never recommend going down the pay day loans route -
                they will only make things worse.{' '}
            </Text>
            <Text>
                However if you simply want to get a bad credit loan to improve
                your credit rating then bad credit loans can be useful, however
                you must be sure that you can repay the entire loan and not fall
                behind on monthly repayments, and you need to be aware that you
                will probably end up paying a higher rate of interest than you
                might on other loans or credit cards. Lenders are also likely to
                take into account many other factors, such as your job, salary
                and if you own any property, because, as we mentioned earlier,
                they will see you as a high risk borrower. But if you can keep
                up with repayments and don’t allow the loan to push you further
                into debt that you cannot afford then you will be on the road to
                repairing your credit rating.
            </Text>
        </>
    )
}

export default ContentPoorCredit
